export default __webpack_public_path__ + "static/media/casesTwo5.7ead26ed.webp";